import "can/map/";
import Mark from "front-markjs";

const HelpPageSearchViewModel = can.Map.extend({
    term: "",
    oldTerm: "",
    currentIndex: 0,
    current: 0,
    total: 0,
    searchTerm: function() {

        "use strict";

        // set current term as the old term
        this.attr("oldTerm", this.term );

        // highlight all matched results
        this.highlightResults( this.term );

    },
    searchEnter: function( $ev, $el ) {

        "use strict";

        $ev.preventDefault();
        $ev.stopPropagation();

        var keyCode = $ev.keyCode ? $ev.keyCode : $ev.charCode,
            value = $el.val();

        // key pressed is ENTER key
        if ( keyCode === 13 ) {

            if ( this.term !== this.oldTerm ) {

                // if new search term, highlight new matched results

                this.highlightResults( this.term );
                this.currentIndex = 0;

                if ( $("div.help-page mark").length > 0 ) {
                    this.scrollBy();
                }

            } else {
                // if term is still same, navigate to the next matched result
                this.nextResult();
            }

        } else {

            if ( value !== this.oldTerm ) {

                this.highlightResults( value );

                this.currentIndex = 0;
                this.attr("current", this.currentIndex );
                if ( $("div.help-page mark").length > 0 ) {
                    this.attr("current", this.currentIndex + 1 );
                    this.scrollBy();
                }
            }

        }

        this.attr( "oldTerm", value );

        return false;
    },
    next: function() {
        "use strict";

        this.nextResult();

    },
    prev: function() {
        "use strict";

        this.prevResult();

    },
    nextResult: function() {

        "use strict";

        if ( $("div.help-page mark").length === 0 ) { this.attr("current", 0 ); return false; }

        // set index to the next one of the highlighted match
        this.currentIndex++;

        // if next match is not available, go back to the first matched result
        if ( $("div.help-page mark").eq( this.currentIndex ).length === 0 ) {
            this.currentIndex = 0;
        }

        this.scrollBy();

        return true;

    },
    prevResult: function() {

        "use strict";

        if ( $("div.help-page mark").length === 0 ) { this.attr("current", 0 ); return false; }

        // set index to the previous one of the highlighted match
        this.currentIndex--;

        // if previous match is not available, go to the last matched result
        if ( this.currentIndex < 0 || $("div.help-page mark").eq( this.currentIndex ).length === 0 ) {
            this.currentIndex = $("div.help-page mark").length - 1;
        }

        this.scrollBy();

        return true;
    },
    scrollBy: function() {

        "use strict";

        var dialogBodyTopOffset = this.dialog.$modalBody.offset().top;

        var currentOffsetTop = $("div.help-page mark").eq( this.currentIndex ).offset().top,
            scrollBy = currentOffsetTop - dialogBodyTopOffset;

        $("div.help-page mark").removeClass("bg-primary");

        // highlight the selected match based on index
        $("div.help-page mark").eq( this.currentIndex ).addClass("bg-primary");

        if ( scrollBy < 0 || scrollBy > this.dialog.$modalBody.height() ) {
            // scroll to the selected match based on index
            this.dialog.$modalBody.slimScroll({ scrollBy: parseInt( scrollBy ) + "px" });
        }

        this.attr("current", this.currentIndex + 1 );

    },
    highlightResults: function( text ) {

        "use strict";

        var self = this;

        // set container element to check matches of the search term
        var instance = new Mark( document.querySelector("div.help-page") );

        instance.unmark();

        // mark all match results
        instance.mark( text, {
            "element": "mark",
            "separateWordSearch": false,
            "done": function(counter){
                // counter is a counter indicating the total number of all marks
                self.attr( "total", counter );
                self.attr( "current", 0 );
            },
            "noMatch": function( term ){
                // term is the not found term
                self.attr( "current", 0 );
            }
        });

    }
});

export default HelpPageSearchViewModel;
